import { render } from "./Building.vue?vue&type=template&id=fe62531c"
import script from "./Building.vue?vue&type=script&lang=js"
export * from "./Building.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__